module.exports = __webpack_public_path__ + "img/top-tracer-menu-logo.4ac91f83.png";